/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "faac2553ecad77c150ddeb182d077389174ddd85";
